import React from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from '../../../config/Translate';
import validator from 'validator';
import axios from 'axios';
import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined';
import { defaultVariabls } from '../../../config/index';
import {setStore, getStore, connect} from "trim-redux";
import {Link, withRouter} from 'react-router-dom';
import {withSnackbar} from "notistack";
import LoadingButton from "../../components/elements/LoadingButton";
import {passwordRegx, secret} from "../../../config/Security";
import HeaderTags from "../../components/elements/HeaderTags";
import AuthLayout from "../../components/layouts/AuthLayout";
import Box from "@material-ui/core/Box/Box";
import PassField from "../../components/fields/PassField";
import RadioGroup from "@material-ui/core/RadioGroup/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Radio from "@material-ui/core/Radio/Radio";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import FormControl from "@material-ui/core/FormControl/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText/FormHelperText";
import Feature from "../../components/elements/Feature";
import LockOpenTwoToneIcon from "@material-ui/core/SvgIcon/SvgIcon";
import GroupAddTwoToneIcon from '@material-ui/icons/GroupAddTwoTone';
import Hidden from "@material-ui/core/Hidden/Hidden";
import Button from "@material-ui/core/Button/Button";
import Alert from "@material-ui/lab/Alert/Alert";
import {shopTypesWithName} from "../../../config/Permissions";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
class Register extends React.Component {
    constructor(props){
        super(props);
        if(getStore().isAuth){
            this.handleLogout()
        }
        this.state={
            fields: {
                first_name: '',
                last_name: '',
                email:'',
                mobile:'',
                role:'user',
                password:'',
                password_confirmation: '',
                shop_type:'normal'
            },
            errors:{},
            SubmitLoading:false,
            policy_confirmation:false,
            success:false
        };
    }
    handleChange(e){
        let {fields,errors} = this.state;
        let target = e.target;
        errors[target.name] = "";
        fields[target.name] = target.value;
        this.setState({fields});
    }
    handleLogout(){
        localStorage.removeItem('ACT');
        localStorage.removeItem('RET');
        setStore({
            isAuth : false,
            user : null,
        });
    }

    handleValidation(callback){
        let { fields ,policy_confirmation} = this.state;
        let errors = {};
        let formIsValid = true;

        //policy_confirmation
        if(!policy_confirmation ) {
            formIsValid = false;
            errors['policy_confirmation'] = Translate.pleaseCheckTheBox;
        }
        //mobile
        if(!validator.isNumeric(fields.mobile) || fields.mobile.length !== 11){
            formIsValid = false;
            errors['mobile'] = Translate.wrongMobile;
        }

        //check Email and Mobile
        let data = new FormData();
        data.append('mobile', fields.mobile);
        const loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        const request = async () => {
            if(errors['mobile'] === undefined) {
                await axios.post(`${defaultVariabls.url}/register/checkMobile`, data, config)
                    .then(response => {
                        if(response.data.errors.mobile !== undefined){
                            formIsValid = false;
                            errors['mobile'] = response.data.errors.mobile[0];
                        }
                    }).catch(error => {
                    });
            }
            await this.setState({errors},() =>{
                if(!formIsValid){
                    this.setState({
                        SubmitLoading:false
                    })
                }
                return callback(formIsValid)
            });
        }
        request();
    }
    async handleRequest(){
        const {first_name,last_name,email,mobile, password,password_confirmation,role,shop_type} = this.state.fields;
        let data = new FormData();
        data.append('secret', secret);
        data.append('mobile', mobile);
        data.append('role', role);
        data.append('avatar', "2");
        let config = {
            headers: {
                Accept: 'application/json',
            }
        };
        await axios.post(`${defaultVariabls.url}/register_first`, data, config)
            .then(response =>{
                localStorage.setItem('ACT',response.data.accessToken);
            })
            .catch(error =>{
                console.log(error.response)
                this.setState({
                    SubmitLoading:false
                })
                this.props.enqueueSnackbar(Translate.registerError, {
                    variant: 'error',
                });
            });
        const loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/checkLogin`, config)
                .then(response => {
                    setStore({
                        isAuth : true,
                        user : response.data,
                    });
                    this.setState({
                        SubmitLoading:false,
                        success:true
                    })

                }).catch(error => {
                setStore({
                    isAuth : false,
                    user : null,
                });
                this.setState({
                    SubmitLoading:false
                })
                this.props.enqueueSnackbar(Translate.registerError, {
                    variant: 'error',
                });
            })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                SubmitLoading:false
            })
        }
        if (this.props.isAuth){
            let code = this.props.user.login_token;
            window.location.replace(`${defaultVariabls.website}/loginFromPanel/${mobile}/${code}`);
        }
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading:true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }
    render() {
        const {classes} = this.props;
        const {errors,SubmitLoading,success,policy_confirmation} = this.state;
        return (
            <AuthLayout>
                <HeaderTags title={Translate.register}/>
                <Grid item xs={11} md={11} lg={10} style={{marginTop:20,marginBottom:20}}>
                    <Box mb={{xs: 3, xl: 8}}  fontSize={18}>
                        <strong className={classes.auth_title}>
                            <PersonAddOutlinedIcon style={{marginLeft:10}} color="primary"/>
                            {Translate.register}
                            </strong>
                    </Box>
                    <form className={classes.form} noValidate onSubmit={this.handleSubmit.bind(this)}>
                        <Grid container spacing={2} justify="center" alignItems='center'>
                            {/*<Feature check="marketplace">
                                <Grid item xs={12}>
                                    <RadioGroup aria-label="role" name="role" value={this.state.fields.role} onChange={this.handleChange.bind(this)}>
                                        <Grid container>
                                            <Grid item xs={12} style={{textAlign:"right"}}>
                                                <FormControlLabel value="user" control={<Radio />} label={Translate.buyer} />
                                                <FormControlLabel
                                                    value="supplier"
                                                    control={<Radio />}
                                                    label={Translate.supplier}
                                                />
                                            </Grid>
                                        </Grid>
                                    </RadioGroup>
                                </Grid>
                            </Feature>*/}
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    variant="outlined"
                                    id="mobile"
                                    label={Translate.mobile}
                                    placeholder={Translate.mobileSample}
                                    name="mobile"
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['mobile']}
                                    helperText={errors['mobile'] }
                                />
                            </Grid>

                            {/*{
                                this.state.fields.role === "supplier" &&
                                <Grid item xs={12}>
                                    <Alert severity="info">
                                        {Translate.supplierRegisterText}
                                    </Alert>
                                </Grid>
                            }*/}
                                <Grid item xs={12} style={{textAlign:"right"}}>
                                    <FormControl required error={!!errors['policy_confirmation']} component="fieldset">
                                        <FormControlLabel
                                            control={<Checkbox checked={policy_confirmation} onChange={() => this.setState({policy_confirmation:!policy_confirmation})} />}
                                            label={
                                                <Typography className="privacy_policy">
                                                    {Translate.with}
                                                    {" "}
                                                    <a target="_blank" href={`${defaultVariabls.website}/terms-and-conditions`} >
                                                        {Translate.rules}
                                                    </a>
                                                    {" "}
                                                    {Translate.privacyPolicyConfirmation}
                                                </Typography>
                                            }
                                        />
                                        {
                                            !!errors['policy_confirmation'] &&
                                            <FormHelperText>{errors['policy_confirmation']}</FormHelperText>

                                        }
                                    </FormControl>
                                </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <LoadingButton
                                type="submit"
                                variant="contained"
                                color="secondary"
                                size="large"
                                style={{width:"100%"}}
                                styleForParent={{marginBottom:0}}
                                onClick = {this.handleSubmit.bind(this)}
                                loading = {SubmitLoading}
                                success = {success}
                            >
                                {Translate.register}
                            </LoadingButton>
                        </Grid>
                        <Grid item xs={12} style={{textAlign:"right",marginTop:15}}>
                            <Typography>
                                    {Translate.haveAccount}
                                <Button size={"small"} component={Link} color="primary" to="/login">
                                    <strong>
                                        {Translate.doLogin}
                                    </strong>
                                </Button>
                            </Typography>
                        </Grid>
                    </form>
                </Grid>

            </AuthLayout>
        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(Register))));